import { Tags } from './types';

export const TAGS: Tags = {
    text: 'input',
    textarea: 'textarea',
    password: 'input',
    number: 'input',
    checkbox: 'input',
};
